<template>

      <section class="home_banner_section">
        <a-carousel autoplay v-model="bannerActive" height="800px"  :style="{ backgroundColor: `#FFF` }"  >
          <div :key="index" :id="index"  v-for="(item, index) in bannerCarousels">      
            <img class="carousel_img" :src="item.NewsPhoto"  />
          </div>
        </a-carousel>
      </section>
      <section class="home_login_section">        
        <loginForm />
      </section>
      <section class="home_aboutus">
        <div class="aboutus_title">
        
        </div>
        <div class="aboutus_content">


          <a-card :style="{border: 'none',boxShadow: 'none'}" :bordered="false" :body-style="{ padding: 0, border:0, overflow: 'hidden' }">
            <a-flex justify="space-between">
              <img
                alt="avatar"
                src="../assets/images/home_aboutus.jpg"
                
              />
              <a-flex vertical align="flex-end" justify="space-between" >
                <a-typography-title :level="3"><img src="../assets/images/home_aboutus_title.png"> </a-typography-title>
                <a-typography style="padding: 35px; line-height: 26px;">
                  <a-typography-title :level="5" style="margin-bottom: 24px;">深圳春秋国际旅行社有限公司</a-typography-title>
                  <p>春秋文旅成立于2010年，拥有旅行社出入境资质，是广东3A级旅行社，蝉联广东省百强旅行社荣誉。公司打造“资源+平台+服务”的旅游生态闭环，以“酒旅+新媒体”构建多平台多渠道酒店营销精细化运营体系，赋能酒店实现业务大幅增长。</p> 

                  <a href="/aboutus" style="float: right; margin-top: 20px;">
                    <a-button type="text">了解更多>></a-button>
                  </a>
                </a-typography>
              
              </a-flex>
            </a-flex>
          </a-card>


        
        </div>
      </section>
      <section class="home_swiper_section">        
        <homeSwiper />
      </section>
      <section class="home_youshi_section">
        <div class="home_youshi_content">
          <div class="home_youshi nd-flex space-between">
              <div class="youshi_item">
                
                <div class="youshi_text">国际酒店集团合作</div>
                <div class="youshi_subtext">25+</div>
              </div>

              <div class="youshi_item">
                
                <div class="youshi_text">酒店资源</div>
                <div class="youshi_subtext">30W+</div>
              </div>

              <div class="youshi_item">
                
                <div class="youshi_text">直采酒店</div>
                <div class="youshi_subtext">8000+</div>
              </div>
          </div>

        </div>
       
      </section>

     <section class="hotel_promotion_section">
        <hotelPromotion />
     </section>

     <div class="home_page_bottom nd-flex space-between">
        <div class="home_page_contactus">
          <p style="margin-bottom: 60px;">深圳春秋国际旅行社有限公司</p>
          <p style="font-weight: 700;"><PhoneOutlined /> &nbsp;&nbsp;&nbsp; 0755-82283588</p>
          <p style="font-size: smaller;">
            地址：深圳市罗湖区深南东路2105中建大厦19号1931室<br>
            邮编：518004
          </p>
        </div>
        <div class="home_page_quickLink">
          <a href="/" class="quickLink_item">首页</a>
          <a href="/aboutus" class="quickLink_item">关于我们</a>
          <a href="/reg" class="quickLink_item">申请加盟</a>
          <a href="/agreement" class="quickLink_item">合作协议</a>
        </div>
        <div class="home_page_qrcode">
           <a-row :gutter="16">
            <a-col :span="12">
              <img src="@/assets/images/gongzonghao.jpg" width="140" height="140" >
              <p>微信公众号</p>
            </a-col>
            <a-col :span="12">
              <img src="@/assets/images/B2BWechat.jpg" width="140" height="140" >
              <p>微信小程序</p>
            </a-col>
          </a-row>
        </div>
     </div>
</template>

<script>
import '@/assets/styles/home.css'
//import hotSaleHotel from '@/components/hotSaleHotels.vue'
import hotelPromotion from '@/components/hotelPromotion.vue'
import loginForm from '@/components/loginForm.vue'
import homeSwiper from '@/components/homeSwiper.vue'
import { PhoneOutlined} from '@ant-design/icons-vue';
export default {
  name: 'HomePage',
  data(){
    return{
      bannerActive:0,
      bannerCarousels:[],
      copyRight:""
    }
    
  },
  mounted() {
    this.fetchCarousel();
    document.title = this.$route.meta.title;
  },
  components: {
    //hotSaleHotel,
    hotelPromotion,
    loginForm,
    homeSwiper,
    PhoneOutlined
    
  },
  methods: {
    fetchCarousel(){
      this.$axios.post('/carousel')
      .then(response =>{
      
        if (response.data.RetCode == "Success") {
          var banners=response.data.Banners.filter(banner => banner.BannerType === "b2bindex1" && banner.Status==1)
          //console.log(banners)
          this.bannerCarousels=banners
          this.bannerActive=0;
          this.copyRight=response.data.Company.RecordFiling;
        } else {
          console.log(response.data)
        }

      });
    },
    handleSelect(city) {
      console.log('Selected city:', city);
      // 处理选中的城市逻辑
    }
  }
}
</script>


<style scoped>

  .carousel_img{   
  height:800px;
  width: 100%;
  background-size: cover; /* 确保图片铺满 */
  background-position: center; /* 中心对齐 */
  background-repeat: no-repeat; /* 禁止重复 */
  text-indent: -9999;
}
.home_page_bottom{width: 1200px; margin: 0 auto; padding-top: 200px; font-size: 14px; color: #fff;}
.home_page_contactus p{margin-bottom: 10px; line-height: 28px;}
.home_page_qrcode{text-align: center; color: #fff;}
.home_page_qrcode p{margin-top: 10px;}
.home_page_quickLink a{padding: 0 20px; color: #fff; opacity: 0.8;}
.home_page_quickLink a:hover{opacity: 1; color: #fff;}
</style>